import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { ModalComponent } from '../../layout/modals/ModalComponent';
import { FormField } from '../../layout/form-fields/FormField';
import { recruiterStore } from './RecruiterStore';

const ValidationSchema = Yup.object().shape({
	name: Yup.string().required().label('Name')
});

export class RecruiterCreate extends ModalComponent {
	render() {
		return (
			<Formik
				initialValues={{
					name: '',
					email: '',
					disabled: false
				}}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.save(values);
				}}>
				{formikBag => this.renderModalContainer(formikBag, 'RecruiterCreate')}
			</Formik>
		);
	}

	renderForm(formikBag) {
		return (
			<div className="columns is-multiline">
				<div className="column is-full">
					<FormField
						required
						className="has-text-left"
						label="Name"
						field="name"
						type="text"
						placeholder="Name"
					/>
				</div>
				<div className="column is-full">
					<FormField
						required
						className="has-text-left"
						label="Email"
						field="email"
						type="text"
						placeholder="Email"
					/>
				</div>
				<div className="column is-full has-text-left">
					<div className="control">
						<label className="checkbox subtitle is-7">
							<input
								type="checkbox"
								defaultChecked={formikBag.values.disabled}
								onClick={clickEvent => {
									formikBag.setFieldValue(
										'disabled',
										clickEvent.target.checked
									);
								}}
							/>{' '}
							Inactive
						</label>
					</div>
				</div>
			</div>
		);
	}

	async save(values) {
		recruiterStore
			.create({
				name: values.name,
				email: values.email,
				disabled: values.disabled
			})
			.then(result => {
				this.resultNotification(result, 'Recruiter', 'Create');
			});
	}
}
